export const BASE_URL = window.__env ? window.__env.backendHost + 'anapath/api' : 'imOnATest!'
export const WEBSOCKET_BASE_URL = window.__env ? window.__env.backendHost + 'anapath/websocket' : 'imOnATest!'
export const VIEWER_BASE_URL = window.__env ? window.__env.backendHost + 'anapath/viewer/api' : 'imOnATest!'
